import React, {useEffect, useState} from "react";
import {is_admin_user} from "../../app/role";
import axios from "axios";
import HttpError from "../base/HttpError";
import {Skeleton} from "antd/es";
import {Avatar, Row, Table, Tag} from "antd";
import {getAllGalleryArtists} from "../../api/userGalleryArtists";
import MyPagination from "../MyPagination";
import {UserOutlined} from "@ant-design/icons";


export default function (props) {

    const onClickArtist = (artist_id, user_id, email, name) => {

        props.switchArtist({
            id: props.id, // login user Id
            token: props.token, // login user token
            artistId: artist_id, //artist obj id
            userId: user_id, // artist user Id
            email: email, // login user email
            role: props.role, // staff, admin or artists
            admin_email: props.admin_email, // admin user email
            artistName: name
        })

        setTimeout(() => {
            window.location.reload()
        }, 300)
    }

    const getName = (record) => {
        return (record.first_name ?? '') + " " + (record.last_name ?? '')
    }

    const getAvatar = (src, first_name) => {
        if (src && src !== '/webstatic/assets/demo/avatars/profile.png') {
            return <Avatar src={src}/>
        } else {
            return <Avatar
                style={{
                    cursor: 'pointer'
                }}
                icon={<UserOutlined/>}
            />
        }
    }

    function onSorter(fields) {
        console.log(fields)
    }

    function formatDate(timestampRange) {
        // Split the timestamp range into start and end timestamps
        const [startTimestamp, endTimestamp] = timestampRange.split(" - ");

        // Extract the date part from the timestamps
        const startDate = startTimestamp.split("T")[0];
        const endDate = endTimestamp.split("T")[0];

        // Output the formatted date range
        return startDate + " - " + endDate;
    }

    const artistsColumns = [
        {
            title: 'ID',
            dataIndex: 'artist_id',
            key: 'artist_id',
            render: (text, record) => (
                <>
                    {text}
                </>
            )
        },
        {
            title: 'Avatar',
            dataIndex: 'avatar',
            key: 'avatar',
            render: (text, record) => (
                <div style={{display: 'flex', flexDirection: 'row', gap: 12}}>
                    {getAvatar(text, record.first_name)}
                    <div style={{display: 'flex', flexDirection: 'column'}}>
                        <div style={{fontSize: 10}}>{record.email}</div>
                        <div style={{fontSize: 10}}>{record.first_name + " " + record.last_name}</div>
                    </div>
                </div>
            )
        },
         {
            title: 'Plan',
            dataIndex: 'sam_plan',
            key: 'sam_plan',
            render: (text, record) => (
                <Tag style={{fontSize: 10}}>{text}</Tag>
            )
        },
        {
            title: 'Plan Date',
            dataIndex: 'sam_plan_date',
            key: 'sam_plan_date',
            render: (text, record) => (
                <div style={{fontSize: 10}}>{formatDate(`${record.sam_plan_start_at} - ${record.sam_plan_expire_at}`)}</div>
            )
        },
        {
            title: 'Date Joined',
            dataIndex: 'date_joined',
            key: 'date_joined',
            render: (text, record) => (
                <div style={{fontSize: 10}}>{new Date(text).toLocaleDateString()}</div>
            )
        },
        {
            title: 'Last Login',
            dataIndex: 'last_login',
            key: 'last_login',
            render: (text, record) => (
                <div style={{fontSize: 10}}>{new Date(text).toLocaleDateString()}</div>
            ),
        },
    ]

    const [loadingArtists, setLoadingArtists] = useState(false)
    const [dataSource, setDataSource] = useState([])
    const [total, setTotal] = useState(0)
    const [current, setCurrent] = useState(1)
    const [pageSize, setPageSize] = useState(12)

    function requestData(pageNum, pageSize) {
        setLoadingArtists(true)
        getAllGalleryArtists(pageNum, pageSize).then((res) => {
            setTotal(res.data.count)
            setDataSource(res.data.results)
        }).catch((error) => {
            if (axios.isCancel(error)) {
                return
            }
            HttpError(error)
        }).finally(() => {
            setLoadingArtists(false)
        })
    }

    useEffect(() => {
        if (is_admin_user(props) && !props.artistId) {
            requestData(current, pageSize)
        }
    }, [props])

    if (loadingArtists) {
        return <>
            <Skeleton/>
            <Skeleton/>
            <Skeleton/>
            <Skeleton/>
            <Skeleton/>
        </>
    }

    function onPaginationChange(page) {
        setCurrent(page)
        requestData(page, pageSize)
    }

    function onShowSizeChange(current, pageSize) {
        setCurrent(1)
        setPageSize(pageSize)
        requestData(1, pageSize)
    }

    function bottomPagination() {
        return (
            <>
                <Row justify='center'>
                    <MyPagination
                        showQuickJumper
                        showSizeChanger={true}
                        total={total}
                        current={current}
                        defaultPageSize={pageSize}
                        pageSize={pageSize}
                        showTotal={(total) => `Total ${total} artists`}
                        onChange={onPaginationChange}
                        onShowSizeChange={onShowSizeChange}
                    />
                </Row>
            </>
        )
    }

    return (
        <>
            <Table pagination={false}
                   scroll={{x: props.tableWidth ?? 800}}
                   columns={artistsColumns.filter(item => !item.hidden)}
                   dataSource={dataSource}/>
            <div style={{marginTop: 24}}>
                {bottomPagination()}
            </div>
        </>
    )
}